import { toast } from "react-toastify";
import "./PtsAlert.css";

const PtsAlert = {
  success(msg, options = {}) {
    return toast.success(msg, {
      ...options,
      autoClose: 2000,
      icon: false,
      className: "toast-success-container toast-success-container-after",
    });
  },
  error(msg, options = {}) {
    return toast.error(msg, {
      ...options,
      autoClose: 1000,
      className: "toast-error-container toast-error-container-after",
    });
  },
  warn(msg, options = {}) {
    return toast.warn(msg, {
      ...options,
      className: "toast-warn-container toast-warn-container-after",
    });
  },
};

export default PtsAlert;
